import { ReadableStream as ReadableStreamPolyfill } from 'web-streams-polyfill/ponyfill'
import { isFirefox } from './utils';
import { sendToBackground } from "@plasmohq/messaging"

export const BackgroundEventNames = {
    fetch: 'fetch',
    vocabularyService: 'vocabularyService',
    actionService: 'actionService',
    getItem: 'getItem',
    setItem: 'setItem',
    removeItem: 'removeItem',
}

export interface BackgroundFetchRequestMessage {
    type: 'open' | 'abort'
    details?: { url: string; options: RequestInit }
}

export interface BackgroundFetchResponseMessage
    extends Pick<Response, 'ok' | 'status' | 'statusText' | 'redirected' | 'type' | 'url'> {
    error?: { message: string; name: string }
    status: number
    data?: string
}

async function readText(stream: ReadableStream) {
    const reader = stream.getReader()
    let text = ''
    // eslint-disable-next-line no-constant-condition
    while (true) {
        const { done, value } = await reader.read()
        if (done) {
            break
        }
        const str = new TextDecoder().decode(value)
        text += str
    }
    return text
}

export async function backgroundFetch(input: string, options: RequestInit) {
    return new Promise<Response>((resolve, reject) => {
        ;(async () => {
            const { signal, ...fetchOptions } = options
            if (signal?.aborted) {
                reject(new DOMException('Aborted', 'AbortError'))
                return
            }

            const ReadableStream = isFirefox()
                ? (ReadableStreamPolyfill as typeof window.ReadableStream)
                : window.ReadableStream
            const textEncoder = new TextEncoder()
            let resolved = false
            const message: BackgroundFetchRequestMessage = {
                type: 'open',
                details: { url: input, options: fetchOptions },
            }

            const readableStream = new ReadableStream({
                start(controller) {
                    sendToBackground({
                        name: "speaking" as never,
                        body: message
                    }).then((response: BackgroundFetchResponseMessage) => {
                        const { data, error, ...restResp } = response
                        if (error) {
                            const e = new Error()
                            e.message = error.message
                            e.name = error.name
                            controller.error(e)
                            return
                        }
                        controller.enqueue(textEncoder.encode(data))
                        if (!resolved) {
                            resolve({
                                ...restResp,
                                body: readableStream,
                                text: () => readText(readableStream),
                                json: async () => {
                                    const text = await readText(readableStream)
                                    return JSON.parse(text)
                                },
                            } as unknown as Response)
                            resolved = true
                        }
                        controller.close()
                    }).catch(error => {
                        controller.error(error)
                    })

                    signal?.addEventListener('abort', () => {
                        sendToBackground({
                            name: BackgroundEventNames.fetch as never,
                            body: { type: 'abort' }
                        })
                    })
                },
            })
        })()
    })
}